// Shared constants & helpers for the suppliers feature.

export const STANDARD_UNITS = [
  "pièce", "unité", "kg", "g", "L", "mL", "m", "m²", "m³",
  "bidon", "seau", "pot", "sac", "lot", "pack", "carton", "palette",
];

// Match backend GLOBAL_UNIT_CONVERSIONS_TEMPLATE.
export const GLOBAL_UNIT_CONVERSIONS = {
  kg: 1, g: 0.001,
  L: 1, mL: 0.001,
  m: 1, cm: 0.01, mm: 0.001,
  "m²": 1, "cm²": 0.0001,
};

const DIMENSION_GROUPS = [
  new Set(["kg", "g"]),
  new Set(["L", "mL"]),
  new Set(["m", "cm", "mm"]),
  new Set(["m²", "cm²"]),
];

/**
 * Resolve how many `referenceUnit` equal 1 `unit` for a given product (or null).
 * Checks product-level conversions first, then global same-dimension conversions.
 */
export function resolveConversion(product, unit) {
  if (!product) return null;
  const refUnit = product.reference_unit;
  if (!refUnit) return null;
  if (unit === refUnit) return 1;
  const perProd = (product.conversions || {})[unit];
  if (perProd != null && !Number.isNaN(Number(perProd))) return Number(perProd);
  for (const group of DIMENSION_GROUPS) {
    if (group.has(unit) && group.has(refUnit)) {
      return GLOBAL_UNIT_CONVERSIONS[unit] / GLOBAL_UNIT_CONVERSIONS[refUnit];
    }
  }
  return null;
}

/**
 * Returns the price per `referenceUnit` given a price entry (amount / quantity / unit)
 * or null if conversion is impossible.
 */
export function pricePerReferenceUnit(product, amount, quantity, unit) {
  const ratio = resolveConversion(product, unit);
  if (ratio == null || !quantity || quantity <= 0) return null;
  const total = Number(quantity) * ratio;
  if (total <= 0) return null;
  return Number(amount) / total;
}

/**
 * Returns price per "consumption_per_unit" (e.g. €/m²) given
 * the price per reference unit and the product.consumption_quantity/unit.
 * Returns null if consumption isn't configured.
 */
export function pricePerUsageUnit(product, pricePerRef) {
  if (pricePerRef == null) return null;
  const qty = product?.consumption_quantity;
  const unit = product?.consumption_unit;
  if (qty == null || !unit) return null;
  const ratio = resolveConversion(product, unit);
  if (ratio == null) return null;
  return Number(qty) * ratio * Number(pricePerRef);
}

export const SEVERITY_CONFIG = {
  positive: { label: "Positif", color: "bg-green-100 text-green-800 border-green-200" },
  neutral: { label: "Neutre", color: "bg-slate-100 text-slate-800 border-slate-200" },
  negative: { label: "Négatif", color: "bg-red-100 text-red-800 border-red-200" },
};
